<template>
  <div>
    <!-- ERROR MODAL -->
    <BModal
      v-model="errorModal"
      id="errorModal"
      no-header
      no-footer
      hide-header-close
      no-close-on-backdrop
      no-close-on-esc
    >
      <button
        class="close"
        aria-label="Close"
        title="Close all error"
        style="float:right;margin-top: -12px;margin-right: -5px;"
        @click="closeModal"
        data-testid="close-all-errors"
      >
        <span aria-hidden="true">&times;</span>
      </button>

      <div v-for="(errors, ind) in permissionErrors" :key="ind" class="mb-3">
        <div style="display: flex;">
          <span title="Close Error" style="cursor: pointer;">
            <img
              src="/imageList/errorIcon.png"
              width="25"
              height="25"
              @click="onClose(ind)"
              data-testid="close-single-error"
            />
          </span>
          <span class="classerror">Error Occurred</span>
        </div>

        <div style="display: flex; justify-content: space-between;">
          <h6 style="width: 78%; padding-left: 25px;">
            It seems that your role is missing some permissions to access this feature. Please contact your Trust Admin.
          </h6>
          <h6 v-if="errors.missingPermissions?.length">
            <button
              class="shiftPartnerSwitchButton"
              @click="openDetails(errors.missingPermissions)"
              data-testid="view-error-details"
            >
              View Details
            </button>
          </h6>
        </div>
      </div>
    </BModal>

    <!-- DETAILS MODAL -->
    <BModal
      v-model="detailsModal"
      id="detailsModal"
      no-header
      no-footer
      hide-header-close
      no-close-on-backdrop
      no-close-on-esc
    >
      <button
        class="close"
        aria-label="Close"
        title="Close Details"
        style="float:right;margin-top: -12px;margin-right: -5px;"
        @click="closeDetails"
        data-testid="close-details"
      >
        <span aria-hidden="true">&times;</span>
      </button>

      <h6 class="bankshiftHeaderText">Missing Permissions</h6>
      <div v-for="(item, ind) in details" :key="ind">
        <div>
          <span class="classerror errorDetails">{{ ind + 1 }}.</span>
          <span class="classerror">{{ item }}</span>
        </div>
      </div>
    </BModal>
  </div>
</template>


<script>
import { mapState, mapMutations } from 'vuex';
import { BModal } from 'bootstrap-vue-next';

export default {
  components: {
    BModal,
  },
  data() {
    return {
      errorModal: false,
      detailsModal: false,
      details: [],
    };
  },
  computed: {
    ...mapState({
      permissionErrors: state => {
        return state.permissionErrors;
      },
    }),
  },
  methods: {
    ...mapMutations({
      SET_PERMISSIONS_ERROR: 'SET_PERMISSIONS_ERROR',
    }),

    onClose(ind) {
      const updated = [...this.permissionErrors];
      updated.splice(ind, 1);
      this.SET_PERMISSIONS_ERROR(updated);
    },

    closeModal() {
      this.SET_PERMISSIONS_ERROR([]);
    },

    closeDetails() {
      this.detailsModal = false;
      this.details = [];
    },

    openDetails(data) {
      this.details = data;
      this.detailsModal = true;
    },
  },
  watch: {
  permissionErrors: {
    immediate: true,
    deep: true,
    handler(value) {
      if (!value) return;
        
      // Create unique errors array
      const uniqueErrors = [];
      value.forEach(error => {
        const isDuplicate = uniqueErrors.some(unique => 
          unique.object === error.object &&
          unique.operation === error.operation &&
          JSON.stringify([...unique.missingPermissions].sort()) === 
          JSON.stringify([...error.missingPermissions].sort())
        );
          
        if (!isDuplicate) {
          uniqueErrors.push(error);
        }
      });

      // Only update if we have different number of errors
      if (uniqueErrors.length !== value.length) {
        this.SET_PERMISSIONS_ERROR(uniqueErrors);
      }
        
      this.errorModal = uniqueErrors.length > 0;
    }
  }
}
};
</script>


<style>
.classerror {
  font-family: 'Proxima Nova Regular';
  padding: 2px 20px 20px 10px;
}

#errorModal .modal-body {
  background: linear-gradient(0deg, #FFF5F3, #FFF5F3),
    linear-gradient(0deg, #F4B0A1, #F4B0A1);
  border-radius: 20px;
}

.errorDetails {
  color: #051376;
}
</style>
